{
  "nl": {
    "voiceRecorder": {
      "hints": {
        "transcribing": "Audio-Opname transcriberen..."
      }
    }
  }
}
